import React, { FunctionComponent, useState, useCallback } from 'react';
import digitalApi from '../../../../../common/api/digitalApi';
import errorHandler from '../../../../../common/service/errorHandler';
import Submit from '../../../presentational/actionButtons/customiseSubmit/Submit';
import { ActionButtonsDisplayConfig } from '../ActionButtonsContainer';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../../common/store';
import { currentDealActions } from '../../../../store/reducers/currentDealReducer';

interface IProps {
  config: ActionButtonsDisplayConfig;
}

const CheckoutLiteReserveOnlineButtonContainer: FunctionComponent<IProps> = ({ config }) => {
  const dispatch: AppDispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const onClick = useCallback(() => {
    setIsSubmitting(true);

    if (config.isCheckoutLiteEnabled && config.reserveOnlineUrl) {
      return digitalApi
        .reserveOnline()
        .then(() => {
          (window as any).location = config.reserveOnlineUrl;
        })
        .catch(error => {
          setIsSubmitting(false);
          if (errorHandler.handleError(error) === false) {
            dispatch(currentDealActions.setError(error));
          }
        });
    }
  }, []);

  return <Submit onClick={onClick} disabled={isSubmitting || config.disabled} />;
};

export default CheckoutLiteReserveOnlineButtonContainer;
